import React, { ButtonHTMLAttributes } from "react";
import { FiPlus } from "react-icons/fi";
import { Container } from "./styles";

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  loading?: boolean;
  showPlusIcon?: boolean;
}

export function PrimaryButton({ text, loading = false, showPlusIcon = false, ...rest }: PrimaryButtonProps) {
  return (
    <Container disabled={loading} {...rest}>
      {loading ? (
        <div className="loading" />
      ) : (
        <>
          {showPlusIcon && <FiPlus size={18} />}
          {text}
        </>
      )}
    </Container>
  );
}
